module.exports = "<div class=\"copy\">\n  &copy; 2017 Anna Norbisrath, <a href=\"http://www.web-n-office.de\">Web 'n Office</a>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/AnnaNorbisrath/WebstormProjects/me.rainer.surfschule-wiesensee/src/app/copyright/copyright.component.html
// module id = ../../../../../src/app/copyright/copyright.component.html
// module chunks = main